import { useEffect, useState } from "react";
import { fmtDate } from "@/components/DatePicker";
import api, { formatApiErrorDetail } from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { ClipboardCheck } from "lucide-react";
import { toast } from "sonner";

export function PendingFixReviews({ onReviewed }) {
  const [items, setItems] = useState([]);
  const [notes, setNotes] = useState({});
  const load = () => api.get("/tax-impound/health/fixes/pending").then((r) => setItems(r.data)).catch(() => {});
  useEffect(() => { load(); }, []);
  if (!items.length) return null;
  const review = async (f, decision) => {
    try { const { data } = await api.post("/tax-impound/health/fixes/review", { company_id: f.company_id, key: f.key, decision, note: notes[`${f.company_id}${f.key}`] || "" }); toast.success(decision === "confirmed" ? `Confirmed — ${f.company_name} re-scored to ${data.snapshot?.score}/100 (${data.snapshot?.grade})` : "Sent back to the client"); load(); onReviewed?.(); }
    catch (e) { toast.error(formatApiErrorDetail(e.response?.data?.detail)); }
  };
  return (
    <Card className="p-4 sm:p-5 space-y-3" data-testid="pending-fixes-card">
      <div><h3 className="font-display font-semibold flex items-center gap-2"><ClipboardCheck className="w-4 h-4 text-primary" /> Client fixes awaiting your review</h3><p className="text-xs text-muted-foreground">Clients marked these compliance items as done. Confirm to re-snapshot their score now, or send back with what's still missing.</p></div>
      <ul className="divide-y divide-border rounded-lg border border-border" data-testid="pending-fixes-list">
        {items.map((f) => { const k = `${f.company_id}${f.key}`; return (
          <li key={k} data-testid={`pending-fix-${f.company_id}-${f.key}`} className="p-2.5 text-sm flex flex-wrap items-center gap-2">
            <div className="min-w-0 flex-1"><div className="font-medium">{f.company_name}</div><div className="text-xs text-muted-foreground">{f.text}</div><div className="text-[11px] text-muted-foreground">marked by {f.by} on {fmtDate(f.done_at)}{f.note && ` — "${f.note}"`}</div></div>
            <Input data-testid={`pending-fix-note-${f.company_id}-${f.key}`} className="h-8 w-52 text-xs" placeholder="Note (required to reject)" value={notes[k] || ""} onChange={(e) => setNotes({ ...notes, [k]: e.target.value })} />
            <Button size="sm" className="h-8" data-testid={`pending-fix-confirm-${f.company_id}-${f.key}`} onClick={() => review(f, "confirmed")}>Confirm & re-score</Button>
            <Button size="sm" variant="outline" className="h-8" data-testid={`pending-fix-reject-${f.company_id}-${f.key}`} onClick={() => review(f, "rejected")}>Send back</Button>
          </li>); })}
      </ul>
    </Card>
  );
}
